import { request } from '@tencent/ppd-base-libs';
import { checkActUinRule as checkUserActCgi, CheckActUinRuleReq, CheckActUinRuleRes } from '@tencent/wphk-act-base-cgi';
import { IS_DEBUG } from '../utils/index';

/**
 * 查询用户是否可参与活动
 */
export async function checkUserAct({ checkActList }: CheckActUinRuleReq): Promise<CheckActUinRuleRes> {
  if (!checkActList.length) return {
    userActInfoList: [],
  };
  return checkUserActCgi({ checkActList });
}

/**
 * 从配置系统获取狂赏印配置
 */
export const getEStampAllConfig = async () => {
  const debugPrefix = IS_DEBUG ? '_debug' : '';
  const url = `https://st.moneydata.hk/res/cc/eStampAllConfig/config${debugPrefix}.json?v=${new Date().getTime()}`;
  console.log('读取配置环境：', debugPrefix || '正式');
  const data = await request.loadVtools(url);
  return data;
};
